module.exports = __webpack_public_path__ + "static/media/KZ.b274d040.svg";